var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.333 9.1l1.16.67c.476.27.644.89.387 1.36l-.992 1.73c-.277.48-.882.65-1.358.37l-1.16-.67c-.555.47-1.189.84-1.883 1.09V15c0 .55-.446 1-.991 1H6.513c-.545 0-.99-.45-.99-1v-1.34c-.705-.25-1.34-.62-1.884-1.09l-1.16.67c-.476.27-1.08.11-1.358-.37L.13 11.14c-.268-.48-.11-1.09.366-1.37l1.15-.68c-.06-.35-.099-.72-.099-1.09 0-.37.04-.74.11-1.1l-1.16-.67C.02 5.96-.139 5.34.13 4.86l.99-1.73c.278-.47.883-.64 1.359-.36l1.14.67c.555-.47 1.19-.84 1.883-1.09V1c0-.55.446-1 .992-1h1.982c.545 0 .991.45.991 1v1.36c.704.25 1.339.62 1.884 1.09l1.16-.67c.475-.27 1.08-.11 1.358.37l.99 1.73c.268.48.11 1.09-.366 1.37l-1.16.67c.06.35.1.72.1 1.09 0 .37-.03.73-.1 1.09zM11.46 8c0-2.21-1.775-4-3.965-4C5.314 4 3.53 5.79 3.53 8s1.774 4 3.965 4c2.19 0 3.965-1.79 3.965-4zM9.479 8c0 1.105-.888 2-1.983 2-1.095 0-1.982-.895-1.982-2S6.4 6 7.496 6s1.983.895 1.983 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.f9613aa8d4b20c3a54784eecb40e32ce.svg";
export { ForwardRef as ReactComponent };